import { useQuery } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { axiosClient } from "api/http/config";
import { Stack, Text } from "shared/components/Spor";

export const VersionPage = () => {
  const frontendBranchName = String(import.meta.env.APP_BRANCH_NAME);
  const frontendSha = String(import.meta.env.APP_VERSION);

  const backend = useQuery({
    queryKey: ["version"],
    queryFn: () =>
      axiosClient.get(`${getBackendUrl()}/health`).then((res) => res.data),
  });
  const git = backend.data?.details["drops-backend"].details.git;
  const backendBranchName = git?.branch;
  const backendSha = git?.commit["id.abbrev"];

  return (
    <Stack p="12px" gap="24px">
      <Stack>
        <Text fontWeight={600} variant="lg">
          Frontend
        </Text>
        <Stack>
          <Text fontWeight={600}>Branch</Text>
          <Text>{frontendBranchName}</Text>
        </Stack>
        <Stack>
          <Text fontWeight={600}>SHA (first 7 letters in commit id)</Text>
          <Text>{frontendSha}</Text>
        </Stack>
      </Stack>
      <Stack>
        <Text fontWeight={600} variant="lg">
          Backend
        </Text>
        <Stack>
          <Text fontWeight={600}>Branch</Text>
          <Text>{backendBranchName}</Text>
        </Stack>
        <Stack>
          <Text fontWeight={600}>SHA (first 7 letters in commit id)</Text>
          <Text>{backendSha}</Text>
        </Stack>
      </Stack>
    </Stack>
  );
};
